import * as React from 'react'
import { ImageAndText, Image, Text } from 'components/common/ImageAndText'
import TestimonialBlock from 'components/blocks/inner/TestimonialBlock'

export default function Testimonial({
	quote,
	_rawQuote,
	author,
	title,
	image,
}) {
	return (
		<ImageAndText className="relative z-[1] bg-suede-black text-white">
			{image && (
				<Image
					className="grayscale"
					image={image}
					alt={author}
					draggable={false}
				/>
			)}

			<Text>
				<TestimonialBlock
					quote={_rawQuote || quote}
					author={author}
					title={title}
				/>
			</Text>
		</ImageAndText>
	)
}
